import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpMisStatusReportPrintPage } from '@/features/pcmp/pages/PcmpMisStatusReportPrintPage';
import { pcmpMisStatusReportSearchSchema } from '@/features/pcmp/types/pcmpMisStatusReport.types';

export const Route = createFileRoute('/_print/pcmp/reports/mis-status/print')({
  validateSearch: pcmpMisStatusReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP MIS Status Report">
      <PcmpMisStatusReportPrintPage />
    </ErrorBoundary>
  ),
});
